import { DetailsTab, ExchangeRateTab, OtherTab, PaymentInfoTab } from './tabs';
import type { FormDialogModel } from './hooks/useFormDialog';
import type { TabItem } from '@/components/custom/erp';

export const FormTabs = (dialog: FormDialogModel): TabItem[] => [
  {
    id: 'details',
    label: 'Chi tiết',
    component: (
      <DetailsTab
        rows={dialog.detail.rows}
        selectedRowUuid={dialog.detail.selectedRowUuid}
        selectedCell={dialog.detail.selectedCell}
        handleRowClick={dialog.detail.handleRowClick}
        handleCellClick={dialog.detail.handleCellClick}
        handleAddRow={dialog.detail.handleAddRow}
        handleDeleteRow={dialog.detail.handleDeleteRow}
        handleCopyRow={dialog.detail.handleCopyRow}
        handlePasteRow={dialog.detail.handlePasteRow}
        handleMoveRow={dialog.detail.handleMoveRow}
        handleCellValueChange={dialog.detail.handleCellValueChange}
        onRepeatForRows={dialog.detail.repeatRows}
        formMode={dialog.formMode}
        handleUpdateNonWritableFields={dialog.detail.setNonWritableFields}
        handleUpdatePasteConfigs={dialog.detail.setPasteConfigs}
        isPasting={dialog.detail.isPasting}
      />
    )
  },
  {
    id: 'payment-info',
    label: 'Thông tin thanh toán',
    component: <PaymentInfoTab formMode={dialog.formMode} formState={dialog.formState} />
  },
  {
    id: 'exchange-rate',
    label: 'Tỷ giá',
    component: (
      <ExchangeRateTab
        formMode={dialog.formMode}
        editExchangeRate={dialog.exchangeRate.edit}
        onEditExchangeRateChange={dialog.exchangeRate.setEdit}
      />
    )
  },
  {
    id: 'other',
    label: 'Khác',
    component: <OtherTab formMode={dialog.formMode} rows={dialog.detail.rows} />
  }
];
